import styled from "styled-components";

const RCPROTitreSecteur = ({ title, icon, description }) => {
  return (
    <div className="text-center mb-4 pb-2 position-sticky">
      <StyledRCPROTitreSecteur className="d-center  text-primary font-weight-bold mb-0 py-2 ">
        <span className="title-secteur d-center flex-column px-md-5 px-3 bg-white">
          <i
            className={`fa shadow d-center rounded-circle bg-secondary text-white p-2 ${icon}`}
          />
          <span className="pt-2"> {title}</span>
        </span>
      </StyledRCPROTitreSecteur>
      {description && (
        <small
          style={{
            fontSize: 14,
          }}
          className="text-muted px-3 d-block"
        >
          {description}
        </small>
      )}
    </div>
  );
};

//ajouter une ligne horizontale centrée autour du titre
const StyledRCPROTitreSecteur = styled("h2")`
  position: relative;

  i {
    width: 52px;
    height: 52px;
    font-size: 25px;

    :before {
      position: relative;
      top: 5px;
    }
  }

  .title-secteur {
    position: relative;
    z-index: 1;
  }
`;

export default RCPROTitreSecteur;
